const state = {
  whiteLabelStatus: (String(process.env.WHITE_LABEL_STATUS).toLowerCase() == 'true'),
  whiteLabeLogo: process.env.WHITE_LABEL_LOGO,
  whiteLabelUrl: process.env.WHITE_LABEL_URL,
  whiteLabelTitle: process.env.WHITE_LABEL_TITLE,
  whiteLabelSiteUrl: process.env.SITE_URL,
}
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/white-label/state.js